import { api } from '..'
import { API_URL } from 'config/env'

interface ReportMissingTranslationPayload {
  languageCode: string
  category: string
  keyCode: string
}

export const reportMissingTranslation = (
  payload: ReportMissingTranslationPayload,
): Promise<void> =>
  api
    .post(`${API_URL}/v1/translations/missing`, payload)
    .then(() => undefined)
    .catch(() => undefined)
